import * as React from 'react';

function SvgSearchTableIcon(props) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity={0.3}
        d="M10.72 12.53a.75.75 0 111.06-1.06l3 3a.75.75 0 11-1.06 1.06l-3-3z"
        fill="#748CAD"
      />
      <path
        d="M8.25 12a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zm0 1.5a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5z"
        fill="#748CAD"
      />
    </svg>
  );
}

export default SvgSearchTableIcon;
